import * as React from "react"
import { useEffect } from "react"
import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAdminSkuForm } from "../../@hooks"
import { adminSkuFormErrors } from "../../@signals"


export default function AdminSkuFormSkuImageURL() {
    const { localValue, handleChange } = useAdminSkuForm("imageURL")
    const { errors } = useValidatorSeeker({
        imageURL: localValue
    }, object({
        imageURL: string().required("Image URL is mandatory") // Revisar mensaje
    }))

    useEffect(() => {
        adminSkuFormErrors.value = {
            ...adminSkuFormErrors.value,
            imageURL: errors?.imageURL
        }
    }, [errors?.imageURL])

    return <TextFieldSeeker
        label="SKU URL"
        error={errors?.imageURL}
        value={localValue || ""}
        onChange={e => handleChange(e.target.value)}
    />
}